import { promptVars } from '../variables';
import { structureBasePrompt } from './structureBasePrompt';
export const updateStructurePrompt = structureBasePrompt
    .temp(1)
    .human('Give me a structure of the application')
    .ai(promptVars.structureStmts)
    .human(`Make minimal changes to solve this: ${promptVars.userInput}.`);
//# sourceMappingURL=updateStructurePrompt.js.map